import { PEOPLE_DIRECTORY_PATH, PEOPLE_DIRECTORY_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const peopleDirectoryRoute = createGlobalRoute({
	exact: true,
	name: PEOPLE_DIRECTORY_PAGE,
	path: `${PEOPLE_DIRECTORY_PATH}/:search(search)?`,
	subproduct: 'townsquare-people-team-directory',
	query: ['screen=(SEARCH_PEOPLE)'],
});
